<template>
  <el-dialog
    append-to-body
    class="ticket-recharge-dialog"
    :visible.sync="show"
    :before-close="handleClose"
    width="472px"
  >
    <div class="ticket-recharge-dialog-box">
      <header class="ticket-recharge-dialog-box__header">
        {{ $t('financial.dialog.ticketRecharge') }}
        <span class="ticket-recharge-dialog-resolve">{{ $t('financial.dialog.rateResolve') }}</span>
      </header>
      <section class="ticket-recharge-dialog-box__body">
        <div class="ticket-recharge-dialog-box__item">
          <span class="ticket-recharge-dialog-box__title">{{ $t('financial.dialog.rechargeChoice') }}</span>
          <ul class="ticket-recharge-dialog-list">
            <li
              v-for="(item, index) in ticketList"
              :key="index"
              class="ticket-recharge-dialog-item"
              :class="
                activedIndex === index
                  ? 'ticket-recharge-dialog-item_active'
                  : ''
              "
              @click="activedIndex = index"
            >
              <span class="ticket-recharge-dialog-value">
                <span style="font-size: 24px; line-height: 30px">{{
                  item.score / 100
                }}</span>
                <br />
                <span style="font-size: 12px; line-height: 17px">{{ $t('common.couponUnit') }}</span>
              </span>
            </li>
          </ul>
        </div>
        <div class="ticket-recharge-dialog-box__item" v-if="selectedTicket">
          <span class="ticket-recharge-dialog-box__title">{{ $t('financial.dialog.payableAmount') }}</span>
          <span class="ticket-recharge-dialog-price">
            <span style="font-size: 24px">{{
              selectedTicket.score / 100
            }}</span>
            <span style="font-size: 14px; margin-left: 4px">{{ $t('common.yuan') }}</span></span
          >
        </div>
        <div class="ticket-recharge-dialog-box__item">
          <span class="ticket-recharge-dialog-box__title">{{ $t('financial.dialog.rechargeMethod') }}</span>
          <div class="ticket-recharge-dialog-alipay">
            <img
              src="https://bn-visas-front.oss-cn-hangzhou.aliyuncs.com/images/alipay.png"
              alt="alipay"
              width="24"
              height="24"
            />
            <span class="ticket-recharge-dialog-alipay__name">{{ $t('financial.payment.alipayPay') }}</span>
            <span
              class="el-icon-circle-check ticket-recharge-dialog-alipay__check"
            ></span>
          </div>
        </div>
        <div class="ticket-recharge-dialog-btn">
          <el-button @click="showSubmit">{{ $t('financial.dialog.payNow') }}</el-button>
        </div>
        <p class="ticket-recharge-dialog-tips">{{ $t('financial.dialog.alipayOnly') }}</p>
      </section>
    </div>
  </el-dialog>
</template>

<script>
import _ from 'lodash'
import { getCookie } from '@/utils/util'
import * as financialApi from '@/apis/financial'

export default {
  name: 'ticketRechargeDialog',
  props: {
    show: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      activedIndex: 0,
      ticketList: [],
      channel: '',
    }
  },
  computed: {
    selectedTicket() {
      return this.ticketList[this.activedIndex]
    },
  },
  watch: {
    show(val, oldVal) {
      if (val && !oldVal) {
        const { userInfo } = getCookie()
        if (userInfo) {
          this.channel = userInfo.channel
        }
        if (this.channel === 'lyb') {
          this.ticketList = [
            { score: 10000 },
            { score: 200000 },
            { score: 500000 },
            { score: 1000000 },
            { score: 2000000 },
            { score: 5000000 },
          ]
        } else {
          financialApi.getTicketList().then((data) => {
            this.ticketList = data
          })
        }
      }
    },
  },
  methods: {
    handleClose() {
      this.$emit('update:show', false)
    },
    showSubmit() {
      const value = this.ticketList[this.activedIndex].score
      let { path, query, fullPath } = this.$route

      if (query.total_amount && query.out_trade_no) {
        query = _.omit(query, ['total_amount', 'out_trade_no'])
        _.each(Object.keys(query), (v, i) => {
          let _q = i === 0 ? `?${v}=${query[v]}` : `${v}=${query[v]}`
          path += _q
        })
      } else {
        path = fullPath
      }

      path = path.includes('?') ? path : `${path}?company_name=baoniu`
      const params = {
        totalAmount: value,
        returnUrl: path,
      }
      financialApi.confirmToRecharge(params).then((res) => {
        document.querySelector('body').innerHTML = res
        document.forms[0].submit()
      })
    },
  },
}
</script>

<style lang="scss">
.ticket-recharge-dialog {
  .el-dialog {
    &__header {
      padding: 0;
    }
    &__body {
      padding: 0;
    }
  }
  &-box {
    &__header {
      padding: 20px 20px 10px;
      line-height: 24px;
      font-size: 18px;
      color: #303133;
    }
    &__body {
      padding: 30px 20px;
      color: #606266;
      font-size: 14px;
    }
    &__item {
      display: flex;
      margin-bottom: 16px;
    }
    &__title {
      width: 86px;
      color: $color-black-87;
    }
  }
  &-resolve {
    margin-left: 8px;
    font-size: 14px;
  }
  &-list {
    flex: 1;
    margin-top: 0;
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    padding: 0;
    margin: 0;
    li:nth-child(3n + 1) {
      margin-left: 0;
    }
  }
  &-item {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    margin-left: 8px;
    margin-bottom: 8px;
    width: 110px;
    height: 64px;
    border: 1px solid $color-border;
    border-radius: 6px;
    box-sizing: border-box;
    cursor: pointer;
    &_active {
      background: $color-green-dark;
      border-color: $color-green-dark;
      .ticket-recharge-dialog-value {
        color: $color-white;
      }
    }
  }
  &-value {
    color: $color-black-87;
    text-align: center;
  }
  &-alipay {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0 16px;
    font-size: 14px;
    color: $color-black-87;
    border: 1px solid $color-border;
    border-radius: 8px;
    height: 48px;
    width: 230px;
    &__name {
      margin-right: 8px;
      margin-left: 10px;
      flex: 1;
      justify-content: flex-start;
    }
    &__check {
      font-size: 18px;
      color: $color-green-dark;
    }
  }
  &-btn {
    margin: 8px 0 10px 86px;
    .el-button {
      width: 137px;
      height: 36px;
      background: $color-green-dark;
      border-color: $color-green-dark;
      border-radius: 4px;
      color: $color-white;
      font-size: 14px;
      font-weight: 400;
    }
  }
  &-tips {
    color: $color-black-38;
    font-size: 12px;
    margin-left: 96px;
  }
  &-price {
    color: $color-yellow;
    height: 24px;
    display: flex;
    align-items: center;
  }
}
</style>
